import setKey from 'lodash/set';

import React from 'react';
import styled from 'styled-components';

import AntdModal from 'antd/lib/modal';

import Admin from 'hive-admin';
import ActionWithFormModal from 'hive-admin/src/components/ActionWithFormModal';
import {
  asLocalStorageField,
} from 'hive-admin/src/components/FieldLocalStorage';

import getFilterWithCol from '../helpers/getFilterWithCol';
import modifyFieldConfig from '../helpers/modifyFieldConfig';

export const getSidebarField = field => modifyFieldConfig(
  field,
  (config = {}) => ({
    ...config,
    sidebarFieldOriginalPrepareValueForForm: (
         config.sidebarFieldOriginalPrepareValueForForm
      || config.prepareValueForForm
    ),
    prepareValueForForm: getSidebarField.prepareValueForForm,
  }),
);

getSidebarField.prepareValueForForm = (value, props) => {
  if (props.sidebarFieldOriginalPrepareValueForForm) {
    value = props.sidebarFieldOriginalPrepareValueForForm(value, props);
  }
  let fieldValue = value;
  fieldValue = value?.target?.value;
  if (typeof fieldValue === 'undefined') {
    fieldValue = value?.target?.checked;
    if (typeof fieldValue === 'undefined') {
      fieldValue = value;
      if (typeof fieldValue === 'undefined') {
        fieldValue = value;
      }
    }
  }
  // eslint-disable-next-line prefer-const
  let [parentFieldName, ...fieldNameParts] = props.name.split('.');
  const parentFieldValueCurrent = (
      props.parentForm
    ? props.parentForm.getFieldValue(parentFieldName)
    : props.data?.[parentFieldName]
  );
  let parentFieldValue = fieldValue;
  if (fieldNameParts.length) {
    parentFieldValue = parentFieldValueCurrent || {};
    setKey(parentFieldValue, fieldNameParts.join('.'), fieldValue);
  }
  const fieldsValue = {
    [`${parentFieldName}`]: parentFieldValue,
  };
  // console.log('fieldsValue:', fieldsValue);
  if (props.parentForm) {
    props.parentForm.setFieldsValue(fieldsValue);
  } else if (props.onSidebarChange) {
    props.onSidebarChange(fieldsValue);
  }
  return value;
};

getSidebarField.block = (title, rows = []) => {
  const result = [];
  if (title) {
    result.push(
      asLocalStorageField(['FieldTitle', {
        size: 'small',
        title,
        style: {
          marginBottom: '-10px',
          marginTop: '-20px',
        },
        textStyle: {
          fontWeight: '600',
        },
      }]),
    );
  }
  rows.forEach(row => row.forEach(field => result.push(getFilterWithCol(
    getSidebarField(field),
    24 / row.length,
  ))));
  return result;
};

getSidebarField.section = (titleConfig, fields = []) => {
  const result = [];
  let isCollapsed = null;
  if (titleConfig) {
    isCollapsed = Admin.compileFromLibrary([
      'condition.fieldIsNotTrue',
      titleConfig.name,
    ]);
    result.push(asLocalStorageField(['FieldTitleToggle', {
      initialValue: false,
      style: { margin: '0px', padding: '0px' },
      wrapperProps: { 'data-is-sidebar-toplevel-title': true },
      ...titleConfig,
    }]));
  }
  result.push(...fields.map(field => (
    isCollapsed
    ? modifyFieldConfig(
        field,
        (fieldConfig = {}) => ({
          ...fieldConfig,
          hidden: [
            ...(fieldConfig.hidden || []),
            isCollapsed,
          ],
        }),
      )
    : field
  )));
  return result;
};

const SidebarModalHTML = ({ className, ...props }) => (
  <AntdModal
    {...props}
    wrapClassName={className}
  />
);

const SidebarModal = styled(SidebarModalHTML)`
  .ant-modal {
    position: fixed;
    top: 10px;
    right: 10px;
    /* left: 10px; */
    bottom: 0px;
    width: calc(100% - 20px) !important;
    max-width: 500px;
    transform: none !important;
    .ant-modal-content {
      /* transform: none !important; */
      .ant-modal-header {
        display: none !important;
      }
      border-radius: 0px;
      position: absolute;
      width: 100%;
      max-width: 100%;
      top: 0px;
      right: 0px;
      left: 0px;
      bottom: 0px;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      display: flex;
      flex-direction: column;
      display: flex;
      flex-direction: column;
      .ant-modal-body {
        /* transform: none !important; */
        overflow-y: scroll;
        [data-is-sidebar-toplevel-title="true"] {
          padding-top: 0px !important;
        }
      }
    }
  }
`;

export const CONFIG = {
  label: null,
  // eslint-disable-next-line no-unused-vars
  getModalProps: (props) => ({
    centered: true,
    closable: true,
    // width: '100%',
    destroyOnClose: true,
    header: () => null,
    footer: false,
  }),
  // eslint-disable-next-line no-unused-vars
  renderActionWithFormModal: (modalProps, props) => (
    <SidebarModal
      {...modalProps}
    />
  ),
};

Admin.addToLibrary(
  'ActionWithConnectedFormSidebar',
  (config = {}) => ActionWithFormModal.create({
    ...CONFIG,
    ...config,
  }),
);
